<app-modal [isBodyAquahaze]="true" [isHeaderDarkBlue]="true">
  <div class="two-factor-reminder custom-modal">
    <div class="two-factor-reminder-header header">
      <div class="two-factor-reminder-header__title">
        <span class="two-factor-reminder-header__title--arrow"></span>
        {{ 'two-factor-reminder.modal_title' | translate }}
      </div>
    </div>

    <div class="two-factor-reminder-body body">
      <div class="two-factor-reminder-body__message">
        {{ 'two-factor-reminder.modal_message' | translate }}
      </div>
    </div>

    <div class="two-factor-reminder-actions actions">
      <div class="two-factor-reminder-actions__buttons">
        <app-button
          (click)="goToProfileSettings()"
          >{{ 'two-factor-reminder.configure_button' | translate }}</app-button
        >
        <app-button variant="dark"
          (click)="close()"
          >{{ 'two-factor-reminder.close_button' | translate }}</app-button
        >
      </div>
    </div>
  </div>
</app-modal>
